import { Select, SelectProps } from 'antd';
import React, { FC, CSSProperties } from 'react';
import { hintChildren } from '@/presentation/components/hint-text/hintText';
import styles from '@/presentation/components/tapd-info/index.module.scss';
import { FilterOptions } from '@/proto/alert';

export const RenderSelect: FC <{
  name: string | null | undefined,
  label: string | null | undefined,
  options?: FilterOptions[],
  getNewFields: (changeValue: string | number, name?: string | null) => void,
  value?: string | number | null | undefined,
  handleSelectChange?: (val: string | number, key?: string) => void,
  labelWidth?: string,
  renderSelectWidth?: string,
  style?: CSSProperties,
  selectProps?: SelectProps,
  children?: React.ReactNode,
  inputWidth?: string,
}> = ({
  name,
  label,
  options,
  getNewFields,
  value,
  handleSelectChange,
  labelWidth,
  renderSelectWidth,
  style,
  selectProps,
  children,
}) => (
  <div style={{
    display: 'flex',
    marginBottom: '20px',
    width: renderSelectWidth ?? '300px',
  }}>
    <span className={styles.overflow} style={labelWidth ? { width: labelWidth } : undefined}>
      {hintChildren(label, label)}
    </span>
    <Select
      showSearch
      options={options}
      defaultValue={value}
      value={value}
      optionFilterProp={'label'}
      onChange={(changeValue: string | number) => {
        if (name === 'work_space_id') {
          handleSelectChange?.(changeValue, name);
        }
        if (name === 'mode') {
          handleSelectChange?.(changeValue);
        }
        getNewFields(changeValue, name);
      }}
      style={style ?? { width: '200px' }}
      {...selectProps}
    >{children}</Select>
  </div>
);
